import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-589257a7")

_pushScopeId("data-v-589257a7")
const _hoisted_1 = { class: "toggle-panel" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "title" }, "Allow participant", -1)
const _hoisted_3 = {
  key: 0,
  class: "toggle-mobile"
}
const _hoisted_4 = {
  key: 1,
  class: "toggle-wrap"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ToggleWithText = _resolveComponent("ToggleWithText")
  const _component_Toggle = _resolveComponent("Toggle")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isMobileScreen)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listToggle, (item) => {
            return (_openBlock(), _createBlock(_component_ToggleWithText, {
              title: item,
              isDisabled: _ctx.isDisabled
            }, null, 8, ["title", "isDisabled"]))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isMobileScreen)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listToggle, (item, key) => {
            return (_openBlock(), _createBlock(_component_Toggle, {
              class: "toggle-item",
              id: key,
              text: item,
              isDisabled: _ctx.isDisabled
            }, null, 8, ["id", "text", "isDisabled"]))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
})